import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Row from '../../shared/components/Row';
import Card from '../../shared/components/Card';
import CardHeader from '../../shared/components/card-header/CardHeader';
import { I18nUtils } from '../../../i18n/I18nUtils';
import HeaderSearchRefreshFilterOptions from '../../shared/components/HeaderSearchRefreshFilterOptions';
import Paginator from '../../shared/components/Paginator';
import WorkersTable from './WorkersTable';
import CardBody from '../../shared/components/CardBody';
import * as workerActions from '../actions/workerActions';
import StateManager from '../../shared/utils/StateManager';

class WorkersCard extends React.Component {

    STATE_MANAGER_KEY;

    constructor(props) {
        super(props);

        this.onRefresh = this.onRefresh.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onPage = this.onPage.bind(this);

        this.STATE_MANAGER_KEY = props.managerKey;
        this.state = StateManager.getState(this.STATE_MANAGER_KEY);
    }

    componentWillMount() {
        this.props.workerActions.getWorkersStates();
        this.getWorkers();
    }

    componentDidUpdate(prevProps, prevState) {
        if ( prevState.search !== this.state.search
            || prevState.filter !== this.state.filter
            || prevState.page !== this.state.page ) {
            this.getWorkers();
        }
        StateManager.saveState(this.STATE_MANAGER_KEY, this.state);
    }

    getWorkers() {
        const {
            workerActions,
            includeOnlyContractorWorkers,
            includeOnlyCompanyWorkers,
        } = this.props;

        workerActions.getWorkers(
            this.state.page,
            this.state.search,
            this.state.filter,
            this.props.companyId,
            includeOnlyContractorWorkers,
            includeOnlyCompanyWorkers,
        );
    }

    onRefresh() {
        this.getWorkers();
    }

    onSearch(search) {
        this.setState({ search: search, page: 1 });
    }

    onPage(page) {
        this.setState({ page });
    }

    renderFilterName() {
        const states = _.keyBy(this.props.workersStates, 'id');
        if ( states && states[this.state.filter] ) {
            return states[this.state.filter].name;
        }
        return '';
    }

    renderHeaderOptions() {

        const filterOptions = this.props.workersStates.map((workerState) => {
            return {
                title: workerState.name,
                active: workerState.id === this.state.filter,
                onClick: () => {
                    this.setState({ filter: workerState.id, page: 1 });
                },
            };
        });

        return (
            <HeaderSearchRefreshFilterOptions
                onRefresh={this.onRefresh}
                onSearch={this.onSearch}
                searchText={this.state.search}
                filterOptions={filterOptions}
            />
        );
    }

    renderBody() {
        const {
            workers,
            workersError,
            workersPagination,
            companyColumn,
        } = this.props;

        return (
            <div>
                <WorkersTable
                    data={workers}
                    error={workersError}
                    companyColumn={companyColumn}
                />
                <Paginator
                    data={workersPagination}
                    onPage={this.onPage}
                />
            </div>
        );
    }

    render() {
        return (
            <Row>
                <Card loading={this.props.workersLoading}>
                    <CardHeader
                        title={I18nUtils.tr('TR_TODOS_LOS_TRABAJADORES').toUpperCase()}
                        subtitle={this.renderFilterName()}
                        rightOptions={this.renderHeaderOptions()}
                    />
                    <CardBody>
                        {this.renderBody()}
                    </CardBody>
                </Card>
            </Row>
        );
    }

}

const mapStateToProps = state => {
    let errorMessage = state.workers.workersError;
    if ( !errorMessage && Object.keys(state.workers.workers).length === 0 && !state.workers.workersLoading ) {
        errorMessage = I18nUtils.tr('TR_NO_EXISTEN_RESULTADOS');
    }
    const workers = _.map(state.workers.workers);
    return ( {
        workers: _.sortBy(workers, ['last_name', 'name']),
        workersPagination: state.workers.workersPagination,
        workersLoading: state.workers.workersLoading,
        workersError: errorMessage,
        workersStates: state.workers.workersStates,
    } );
};

const mapDispatchToProps = dispatch => ( {
    workerActions: bindActionCreators(workerActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(WorkersCard);

WorkersCard.propTypes = {
    companyId: PropTypes.string,
    webview: PropTypes.bool,
    includeOnlyContractorWorkers: PropTypes.bool,
    includeOnlyCompanyWorkers: PropTypes.bool,
    companyColumn: PropTypes.oneOf('contractor', 'outsource'),
    managerKey: PropTypes.string,
};

WorkersCard.defaultProps = {
    companyId: null,
    includeOnlyContractorWorkers: false,
    includeOnlyCompanyWorkers: false,
    companyColumn: 'outsource',
    managerKey: 'WORKERS_CARD',
};



// WEBPACK FOOTER //
// ./src/app/worker/components/WorkersCard.jsx